import { render, staticRenderFns } from "./DuplicateMultiplesRecipes.vue?vue&type=template&id=3b48ff05&"
import script from "./DuplicateMultiplesRecipes.vue?vue&type=script&lang=js&"
export * from "./DuplicateMultiplesRecipes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports